import type { Subcategory } from '~/entities/categories'
import type { apiClient } from '~/shared/api/data-ingestion-api'
import { getDocumentStep } from './get-document-step'
import type { UIDocumentStep } from './types'

/**
 * Returns true when the given step token is the document's currently-active
 * (not-yet-validated) step. Returns false for finished documents — every step
 * is past at that point.
 */
export function getIsCurrentStep(
  document: apiClient.Document,
  subcategories: Subcategory[],
  stepToken: UIDocumentStep,
): boolean {
  const currentStep = getDocumentStep(document, subcategories)
  if (currentStep === 'finished') return false
  return currentStep === stepToken
}
